import { render, staticRenderFns } from "./OverviewWarehouse.vue?vue&type=template&id=4aa51fe6&scoped=true&"
import script from "./OverviewWarehouse.vue?vue&type=script&lang=js&"
export * from "./OverviewWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./OverviewWarehouse.vue?vue&type=style&index=0&id=4aa51fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa51fe6",
  null
  
)

export default component.exports